import { render } from "./CguCheckbox.vue?vue&type=template&id=091398fa&scoped=true"
import script from "./CguCheckbox.vue?vue&type=script&lang=js"
export * from "./CguCheckbox.vue?vue&type=script&lang=js"

import "./CguCheckbox.vue?vue&type=style&index=0&id=091398fa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rightcom-spa/rightcom-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091398fa"]])

export default __exports__